import { supabase } from "./supabase";

const inflight = new Map();

export function loadRpc(name) {
  if (!inflight.has(name)) {
    const request = supabase.rpc(name).then(({ data, error }) => {
      if (error) throw new Error(error.message);
      return data;
    }).finally(() => inflight.delete(name));
    inflight.set(name, request);
  }
  return inflight.get(name);
}
